import { z } from "zod";

import { ERROR_MSG } from "@/constants/ErrorMessage.constant";
import { EmploymentType } from "@/interfaces/globals";
import {
  basicValidator,
  emailValidator,
  imageValidator,
  phoneNumberValidator,
  reactSelectValidator,
} from "@/lib/validators";

const EmploymentTypes = Object.values(EmploymentType) as [string, ...string[]];

export const AdminSchema = z.object({
  firstName: basicValidator(true, "First Name is required", 2, 50),
  middleName: basicValidator(false).optional(),
  lastName: basicValidator(true, "Last Name is required", 2, 50),
  email: emailValidator(true, ERROR_MSG.INVALID_EMAIL),
  phoneNumber: phoneNumberValidator(true, ERROR_MSG.INVALID_PHONE),
  address: basicValidator(false),
  image: imageValidator(2, false, ERROR_MSG.INVALID_IMAGE),
  employmentType: z.enum(EmploymentTypes, {
    message: "Employment type is required",
  }),
  workspaces: reactSelectValidator("Select at least one workspace"),
});

export const AdminUpdateSchema = AdminSchema.partial();

export type TAdminSchema = z.infer<typeof AdminSchema>;
export type TAdminUpdateSchema = z.infer<typeof AdminUpdateSchema>;
